<template>
    <div>
        <p class="mb-2">
            업체 답변과 평가자 판정의 "해당없음"이 서로 다른 문항이 있어 점수를 계산할 수 없습니다.<br>
            아래 문항을 평가 화면(새 탭)에서 문항 단위로 해당없음/해당있음 처리하거나 초기화한 뒤 다시 시도해 주세요.
        </p>
        <ul v-if="links.length" class="list-unstyled mb-3">
            <li v-for="link in links" :key="link.key" class="mb-1">
                {{ link.text }}
                <a :href="link.href" target="_blank" rel="noopener" class="ml-2">평가 화면 열기</a>
            </li>
        </ul>
    </div>
</template>

<script>
const {integrityIssueRoute} = require('@shared/store/scoring-integrity-error.cjs');

// 점수 422(문항 안 해당없음 섞임)로 막힌 문항 목록 + 문항별 평가 화면 새 탭 링크
export default {
    name: 'ScoringIntegrityIssueLinks',
    props: {
        // integrityIssues(error) 결과
        issues: {type: Array, required: true},
        projectCode: {type: String, default: null},
        templateCode: {type: String, default: null},
    },
    computed: {
        links() {
            const {client, campaign_name} = this.$route.query;
            const ctx = {
                client, campaign_name,
                admin_mode: this.$store.state.admin_mode,
                project_code: this.projectCode,
                template_code: this.templateCode,
            };
            return this.issues.map(issue => ({
                key: `${issue.campaign_id}-${issue.company_id}-${issue.sub_code}`,
                text: `${issue.label || issue.sub_code} (${issue.sub_code})`,
                href: this.$router.resolve(integrityIssueRoute(issue, ctx)).href,
            }));
        },
    },
};
</script>
